import React from 'react'
import './NotesBackground.scss'

export function NotesBackground() {
    return (
        <div className="notes-background-container">
            <div className="notes-background"></div>
        </div>
    )
}
